import type { GenerateTextCurrentResult } from './generateTextContract'

/** Canonical clipboard payload — full stored result text, never DOM truncation. */
export function getCopyableGenerateTextResult(
  currentResult: GenerateTextCurrentResult | null | undefined,
): string | null {
  const text = currentResult?.text
  if (typeof text !== 'string' || !text.length || !text.trim().length) return null
  return text
}

export async function copyGenerateTextResultToClipboard(text: string): Promise<void> {
  if (!text) return
  await navigator.clipboard.writeText(text)
}
